export function initForContainer($container: JQuery) {
  facebookListener($container);
  twitterListener($container);
  linkedInListener($container);
}

function facebookListener($container: JQuery) {
  $container.find('.fb_share, .js-share-facebook').on('click', (event) => {
    event.preventDefault();
    window.open(
        'https://www.facebook.com/sharer/sharer.php?u=' + window.location,
        'facebookwindow',
        'height=450, width=550, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0, noopener'
        + ', top=' + (getHalfHeight() - 225) + ', left=' + getHalfWidth(),
    );
    return false;
  });
}

function twitterListener($container: JQuery) {
  $container.find('.twitter_share, .js-share-twitter').on('click', (event) => {
    event.preventDefault();
    const $link = $(event.currentTarget);
    window.open(
        'https://twitter.com/share?url=' + window.location + '&text=' + getTitle($link),
        'twitterwindow',
        'height=450, width=550, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0, noopener'
        + ', top=' + (getHalfHeight() - 225) + ', left=' + getHalfWidth(),
    );
  });

}

function linkedInListener($container: JQuery) {
  $container.find('.linkedin_share, .js-share-linkedin').on('click', (event) => {
    event.preventDefault();
    const $link = $(event.currentTarget);
    window.open(
        'http://www.linkedin.com/shareArticle?mini=true&url=' + window.location + '&title=' + getTitle($link),
        'linkedinwindow',
        'height=500, width=600, toolbar=0, location=0, menubar=0, status=1, scrollbars=1, resizable=1, noopener'
        + ', top=' + (getHalfHeight() - 250) + ', left=' + (getHalfWidth() - 300),
    );
  });
}

function getHalfHeight() {
  return $(window).height() || 0 / 2;
}

function getHalfWidth() {
  return $(window).width() || 0 / 2;
}

function getTitle($link: JQuery) {
  return $('meta[property="og:title"]').attr('content') || $link.data('title') || '';

}
